import type { Office, UserProfile } from "../common/types";
import { useMailbox } from "./composables/useMailbox";
import { useVstoInterop } from "./VstoInterop";
import { useUi } from "./composables/useUi";
import { useActions } from "./composables/useActions";
import { enums } from "../common/enums";

export class VstoOffice {
  public readonly HostType = enums.HostType;
  public readonly MailboxEnums = enums.MailboxEnums;
  public readonly AsyncResultStatus = enums.AsyncResultStatus;
  public readonly CoercionType = enums.CoercionType;

  private _context: ReturnType<VstoOffice["initContext"]>;

  public async onReady(cb: Parameters<Office["onReady"]>[0]) {
    const userProfile: UserProfile = await useVstoInterop().getUserProfile();

    this._context = this.initContext(userProfile);

    if (cb) {
      return cb({ host: enums.HostType.Outlook, platform: enums.PlatformType.PC } as any);
    }
  }

  public get context() {
    return this._context;
  }

  public get actions() {
    return { ...useActions() };
  }

  private initContext(userProfile: UserProfile) {
    return {
      mailbox: { ...useMailbox(userProfile) },
      ui: { ...useUi() },
    };
  }
}
